// app/javascript/controllers/cart_modal_controller.js
import { Controller } from "@hotwired/stimulus"

// Controls the Cart modal that is rendered INSIDE <turbo-frame id="cart_modal">
// Opens when the frame finishes loading, and provides close behaviors.
export default class extends Controller {
  static targets = ["container", "panel"]

  connect() {
    // Optional: allow other code to open/close via events
    this._openHandler = () => this.open()
    this._closeHandler = () => this.close()
    document.addEventListener("oe2:cart:open", this._openHandler)
    document.addEventListener("oe2:cart:close", this._closeHandler)
    this._beforeVisitHandler = () => this.unlockScroll()
    document.addEventListener("turbo:before-visit", this._beforeVisitHandler)

    // If content is already present (e.g., from a restore), ensure hidden by default
    if (this.hasContainerTarget) {
      this.containerTarget.classList.add("hidden")
    }
  }

  disconnect() {
    document.removeEventListener("oe2:cart:open", this._openHandler)
    document.removeEventListener("oe2:cart:close", this._closeHandler)
    document.removeEventListener("turbo:before-visit", this._beforeVisitHandler)
    this.unlockScroll()
  }

  // Fired by the Turbo Frame: data-action="turbo:frame-load->cart-modal#open"
  open() {
    if (!this.hasContainerTarget) return
    this.containerTarget.classList.remove("hidden")
    this.lockScroll()

    // Accessibility: focus the panel
    this.panelTarget?.focus()
  }

  close() {
    if (!this.hasContainerTarget) return
    this.containerTarget.classList.add("hidden")
    this.unlockScroll()
    // Clear the frame so the next click re-triggers turbo:frame-load (optional but nice)
    this.element.innerHTML = ""
  }

  // Backdrop click (wired via data-action)
  backdropClose(event) {
    if (event.target === this.containerTarget) this.close()
  }

  // Key handling for Escape (wired via data-action)
  onKeydown(event) {
    if (event.key === "Escape") this.close()
  }

  lockScroll() {
    if (this._scrollLocked) return
    this._scrollLocked = true
    document.documentElement.classList.add("overflow-hidden")
    document.body.classList.add("overflow-hidden")
  }

  unlockScroll() {
    if (!this._scrollLocked) return
    this._scrollLocked = false
    document.documentElement.classList.remove("overflow-hidden")
    document.body.classList.remove("overflow-hidden")
  }
}
